import React from "react";
import { Link, useLocation } from "react-router-dom";
import { RiHome4Line, RiAddCircleLine, RiSearchLine } from "react-icons/ri";
import { FiBookmark } from "react-icons/fi";

const BottomNavigation = () => {
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-gray-100 shadow-lg rounded-t-3xl p-2">
      <ul className="flex justify-around py-2">
        <li>
          <Link
            to="/"
            className={`flex flex-col items-center text-gray-600 hover:text-gray-900 ${
              location.pathname === "/" ? "font-bold" : ""
            }`}
          >
            <RiHome4Line size={26} />
          </Link>
        </li>
        <li>
          <Link
            to="/create-post"
            className={`flex flex-col items-center text-gray-600 hover:text-gray-900 ${
              location.pathname === "/create-post" ? "font-bold" : ""
            }`}
          >
            <RiAddCircleLine size={26} />
          </Link>
        </li>
        <li>
          <Link
            to="/search"
            className={`flex flex-col items-center text-gray-600 hover:text-gray-900 ${
              location.pathname === "/search" ? "font-bold" : ""
            }`}
          >
            <RiSearchLine size={26} />
          </Link>
        </li>
        <li>
          <Link
            to="/saved-post"
            className={`flex flex-col items-center text-gray-600 hover:text-gray-900 ${
              location.pathname === "/saved-post" ? "font-bold" : ""
            }`}
          >
            <FiBookmark size={26} />
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default BottomNavigation;
